import { Component, Inject, OnInit, OnDestroy, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import * as ownActions from '@redux/actions';
import { Subscription } from 'rxjs';
import { DomainBrandService } from '@services/domain-brand.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();
  @Input() data: any;
  urlActiveLevel1: string;
  urlActiveLevel2: string;
  subMenu: boolean = false;
  subMenuTitle: string = 'none';
  openMenu: boolean = false;
  openMenuMobile: boolean = false;
  toggleActive: boolean = false;
  frag: any = '';
  pos: number = 0;
  duration: number = 0;
  myElement: string;
  constructor(
    private _store: Store<AppState>,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
    public brand: DomainBrandService
  ) { }

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el componente
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.setSubscriptions();
    setTimeout(() => {
      if (this.urlActiveLevel1 === 'home' && this.urlActiveLevel2 !== '' || this.urlActiveLevel1 === 'contacts' && this.urlActiveLevel2 !== '') {
        this.frag = '#' + this.urlActiveLevel2;
        this.pos = 100;
        this.scrollPage(this.frag, this.pos, this.urlActiveLevel2);
      }
    }, 50);
  }

  /**
   * -------------------------------------------------------
   * @summary setSubscriptions
   * @description Traer el valor del state del estado del menu de redux
   * -------------------------------------------------------
   */
  setSubscriptions() {
    this._subscription.add(
      this._store.select('layout').subscribe((state) => {
        this.openMenu = state.submenu;
        this.openMenuMobile = state.menu_mobile;
        this.urlActiveLevel1 = state.urlActive1;
        this.urlActiveLevel2 = state.urlActive2;
        // console.log(`this.urlActiveLevel1`, this.urlActiveLevel1);
        // console.log(`this.urlActiveLevel2`, this.urlActiveLevel2);

        switch (this.urlActiveLevel1) {
          case '/home':
            this.activeMenuOnLoad(this.data[0].options, 'inicio')
            break;
          case 'home':
            this.activeMenuOnLoad(this.data[0].options, 'nosotros')
            break;
          case 'productos':
            this.activeMenuOnLoad(this.data[0].options, 'productos')
            break;
          case '/brands':
            this.activeMenuOnLoad(this.data[0].options, 'marcas')
            break;
          case 'contacts':
            this.activeMenuOnLoad(this.data[0].options, 'contáctanos')
            break;
        }

      })
    );
  }


  /**
   * -------------------------------------------------------|
   * @summary activeMenuOnLoad
   * @description Recorrar el array y cambia el status activa del
   * elemento en base a la url a true y los demas a false
   * @param {any} data Array de opciones
   * @param {string} url valor de la url
   * -------------------------------------------------------
   */
  activeMenuOnLoad(data: any, url: string) {
    data.forEach((item) => {
      if (item.title === url) {
        item.active = true;
      } else {
        item.active = false;
        if (item.nodes.length > 0) {
          item.nodes.forEach((subitem) => {
            subitem.active = false;
          });
        }
      }
    });
  }


  /**
   * -------------------------------------------------------
   * @summary scrollPage
   * @description Hace scroll hasta el contenido del fragment seleccionado
   * @param {HTMLElement} element Elemento html o fragment que buscara para hacer scroll
   * @param {number} position Separacion del scroll con el top de la pagina
   * @param {string} frag fragmento
   * -------------------------------------------------------
   */
  scrollPage(element: HTMLElement, position: number, frag: string) {
    switch (frag) {
      case 'scrollabout':
        this.duration = 400;
        break;
      case 'scrollmission':
        this.duration = 600;
        break;
      case 'scrollvalues':
        this.duration = 700;
        break;
      case 'scrollcontacts':
        this.duration = 800;
        break;
      default:
        break;
    }

    if (element !== undefined && this.urlActiveLevel1 !== 'productos' && this.urlActiveLevel2 !== '') {
      setTimeout(() => {
        this.pageScrollService.scroll({
          scrollTarget: element,
          document: this.document,
          duration: this.duration,
          scrollOffset: position,
          verticalScrolling: true,
          interruptible: false,
        });
      }, 300);
    }
  }




  /**
   * -------------------------------------------------------|
   * @summary changeStatus
   * @description Recorrar el array y cambia el status activa del
   * elemento seleccionado a true y los demas a false
   * @param {any} data Array de opciones
   * @param {number} index Posicion del arreglo
   * @param {number} id Element id
   * @param {number} level Nivel del menu
   * @param {any} fragment Nombre del fragmento
   * -------------------------------------------------------
   */
  changeStatusWeb(data: any, index: number, id: number, level: number, fragment: any) {

    // if (this.urlActiveLevel1 !== 'productos' && this.urlActiveLevel2 !== '') {
    //   setTimeout(() => {
    //     this.frag = '#' + this.urlActiveLevel2;
    //     this.pos = 100;
    //     this.scrollPage(this.frag, this.pos);
    //   }, 100);
    // }

    if (data[index].nodes.length > 0) {
      data.forEach((item) => {
        if (item.nodes.length > 0) {
          item.nodes.forEach((subitem) => {
            subitem.active = false;
          });
        } else {
          item.active = false;
        }
      });

      this.urlActiveLevel1 = this.urlActiveLevel1 + '#';
      if (level === 2) {
        data[index].nodes.forEach((subitem) => {
          if (subitem.id === id) {
            subitem.active = true;
            this._store.dispatch(
              ownActions.setColorProduct({ setcolor: subitem.background })
            );
          } else {
            subitem.active = false;
          }
        });
      }
    } else {
      data.forEach((item) => {
        if (item.nodes.length > 0) {
          item.nodes.forEach((subitem) => {
            subitem.active = false;
          });
        } else {
          if (item.id === id) {
            item.active = true;
          } else {
            item.active = false;
          }
        }
      });
    }
  }




  /**
   * -------------------------------------------------------
   * @summary changeStatusMobile
   * @description Recorrar el array y cambia el status activa del
   * elemento seleccionado a true y los demas a false
   * @param {any} data Array de opciones
   * @param {number} index Posicion del arreglo
   * @param {number} id Element id
   * -------------------------------------------------------
   */
  changeStatusMobile(data: any, index: number, id: number) {
    this.toggleActive = true;
    data.forEach((item) => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
    if (data[index].nodes.length > 0) {
      this.urlActiveLevel1 = this.urlActiveLevel1 + '#';
    }
  }

  /**
   * -------------------------------------------------------
   * @summary openToggleMenu
   * @description Toma el item seleccionado con click y pasa los valores
   * para realizar cambio de status y mostrar submenus
   * @param {boolean} value Muestra submenu
   * @param {string} option Titulo de la opcion seleccionada
   * @param {any} data Array de opciones
   * @param {number} index Posicion del arreglo
   * @param {number} id Element id
   * -------------------------------------------------------
   */
  openToggleMenu(
    value: boolean,
    option: string,
    data: any,
    index: number,
    id: number
  ) {
    this.subMenuTitle = option;
    this.subMenu = value;
    this.changeStatusMobile(data, index, id);
  }

  /**
   * -------------------------------------------------------
   * @summary toggleMenuMobile
   * @description Cambia el valor del menu mobile obteniendo valor desde redux
   * -------------------------------------------------------
   */
  toggleMenuMobile() {
    this._store.dispatch(ownActions.toggleMenuMobile());
  }

  /**
   * -------------------------------------------------------
   * @summary ngOnDestroy
   * @description  Destruye conexiones abiertas
   * -------------------------------------------------------
   */
  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
